// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1wkBK","label":"Category_label__8augv","content":"Category_content__1lUwh","header":"Category_header__UPY8B","location":"Category_location__1VlPr"};